import COLORS from '@styles/colors/themes/beam/beam2';
import styled from 'styled-components';

export const CompletionPercentageFileCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 10px;
  margin-bottom: 2px;

  span {
    font-family: 'Poppins' sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #474d66;
    white-space: nowrap;
  }
`;

export const EstimatedElapsedBox = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
`;

export const EstimatedElapsedWrapper = styled.div`
  white-space: nowrap;
  & label,
  span {
    color: ${COLORS.neutral.n800};
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Poppins' sans-serif;
  }
`;
